import React from "react";
import HeaderDrawer from "../../../common/components/HeaderDrawer";
import ListPowerBi from "../../components/ListPowerBi";

const ListPowerBiScreen = (props) => {
  return (
    <HeaderDrawer name="Listagem de Telas">
      <ListPowerBi {...props} onDeleteScreen={(values) => props.deleteScreen(values)} />
    </HeaderDrawer>
  );
};

export default ListPowerBiScreen;
